<template>
<v-dialog v-if="dialog" v-model="dialog" max-width="1100">
  <v-card>
    <v-card-title><h2>{{$t('test.info')}}</h2></v-card-title>
    <v-card-text>
      <p>{{$t('test.max_attempts_info')}}</p>
      <div>
        <v-btn color="teal darken-2" small round>
          <v-icon class="schema-edit-icon">add</v-icon>
        </v-btn>
        {{$t('test.btn_click_info')}}
      </div>

    </v-card-text>


    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" flat="flat" @click="dialog = false">
        {{$t('base.submit')}}
      </v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialog: true,
    }
  },
  computed: {

  },
  methods: {
  }
}
</script>

<style scoped>
</style>
